export default "/_nuxt/f1b050a598a1ab75ddf2e9954c78262b.svg";